import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISFiltersComponent } from './is-filters.component';
import { ISSelectComponent } from '../is-select/is-select.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { SharedModule } from '../shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [ ISFiltersComponent ],
    imports: [ 
        CommonModule,
        MatExpansionModule,
        SharedModule,
        ReactiveFormsModule
    ],
    exports: [ISFiltersComponent],
    providers: [],
})
export class ISFiltersModule {}